import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formatExpectedArrivalDateOrdinal } from '../utils/utils';

/**
 * Блок передзамовлення: суцільний рядок "Передзамовлення, очікується з D-го місяць".
 * Використовується в кошику, підтвердженні замовлення та деталях замовлення в кабінеті.
 */
const PreOrderBlock = ({ expectedArrivalDate, className = '' }) => {
  const dateOrdinal = formatExpectedArrivalDateOrdinal(expectedArrivalDate);
  const badgeText = dateOrdinal
    ? `Передзамовлення, очікується з ${dateOrdinal}`
    : 'Передзамовлення';

  const tooltipText = dateOrdinal
    ? `Товар в передзамовленні, очікується з ${dateOrdinal}`
    : 'Товар в передзамовленні, терміни надходження уточнюйте у менеджера';

  const lastSpace = badgeText.lastIndexOf(' ');
  const beforeLastWord = lastSpace >= 0 ? badgeText.slice(0, lastSpace + 1) : '';
  const lastWord = lastSpace >= 0 ? badgeText.slice(lastSpace + 1) : badgeText;

  return (
    <div className={className} style={{ fontSize: 14 }}>
      <div className="text-success" style={{ fontWeight: 600 }}>
        {beforeLastWord}
        <span style={{ whiteSpace: 'nowrap' }}>
          {lastWord}
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="preorder-tooltip">
                <strong>{tooltipText}</strong>
              </Tooltip>
            }
          >
            <i className="bi bi-info-circle px-1" />
          </OverlayTrigger>
        </span>
      </div>
    </div>
  );
};

export default PreOrderBlock;
